import React from "react";
import Seo from "../seo/Seo";

const SupportPageLayout = ({ title, description, path, children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-gray-900 to-black py-12">
      <Seo title={title} description={description} path={path} />

      <div className="container mx-auto px-6">
        <div className="mx-auto max-w-4xl rounded-3xl border border-white/10 bg-white/5 p-8 shadow-2xl md:p-12">
          <h1 className="text-4xl font-light tracking-tight text-white md:text-5xl">
            {title}
          </h1>
          <p className="mt-5 max-w-3xl text-base leading-relaxed text-gray-300 md:text-lg">
            {description}
          </p>
          <div className="mt-10 space-y-8 text-gray-200">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default SupportPageLayout;
